import React, { useState } from "react";
import { Avatar, Box, Button, Typography } from "@mui/material";
import moment from "moment";
import successImg from "../../Assets/gifs/succes.gif";
import { useNavigate } from "react-router-dom";
import "./QRCodeScanner.css";
import { useDispatch, useSelector } from "react-redux";
import { setNeedsRefetch } from "../../redux/mealHistorySlice";
import GuestListDialogs from "../dash-board/dashboard-dialogs/GuestListDialogs";

const ScanSuccessPage = ({ cityName, mealType }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mealFor = useSelector((state) => state.meal.mealFor);
  const mealCount = useSelector((state) => state.meal.mealCount);
  const guestInfo = useSelector((state) => state.meal.guestInfo);
  const plateCount = useSelector((state) => state.meal.plateCount);
  const [open, setOpen] = useState(false);

  console.log("guestInfo", plateCount);

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const name = user?.firstName + " " + user?.lastName;
  console.log("user", user?.profileImage);

  // const themeColor = "#004D72";

  return (
    <Box className="scan-details-main">
      <Box
        className="scan-user-details"
        // sx={{ backgroundColor: `${themeColor}33` }}
      >
        <Typography variant="h4" mb={1}>
          {name}
        </Typography>
        <Box sx={{ position: "relative" }}>
          <Avatar
            src={`${process.env.REACT_APP_API_IMAGE_URL}${user?.profileImage}`}
            sx={{
              width: 150,
              height: 150,
              fontSize: 40,
              padding: "0.5rem",
              // bgcolor: "#004D72",
              border: "2px solid #004D72",
              mt: 1,
            }}
            variant="outlined"
            // backgroundColor="primary.main"
            imgProps={{ sx: { objectFit: "contain" } }}
          />
          <Avatar
            sx={{
              position: "absolute",
              bottom: 0,
              left: "127px",
              width: "80px",
              height: "80px",
              fontSize: 60,
              padding: "0.5rem",
              bgcolor: "white",
              color: "#004D72",
              border: "2px solid #004D72",
              mt: 1,
            }}
            variant="outlined"
            // backgroundColor="primary.main"
            imgProps={{ sx: { objectFit: "contain" } }}
          >
            {Number(plateCount)}
          </Avatar>
        </Box>
      </Box>
      <Box className="scan-date-place">
        {/* <Typography variant="h2">
          {cityName?.charAt(0).toUpperCase() + cityName.slice(1).toLowerCase()}
        </Typography> */}
        <Typography variant="h2">
          {moment(new Date()).format("MMM D, h:mm a")}
        </Typography>
      </Box>
      <Box className="success-image">
        <img style={{ width: "190px" }} src={successImg} alt="Success" />
      </Box>
      <Box sx={{ padding: "0 2rem" }}>
        {mealFor === "guest" ? (
          <Typography variant="h6">
            You have successfully ordered <br />{" "}
            <strong
              style={{ color: "#004D72", fontSize: "2rem" }}
              onClick={() => setOpen(true)}
            >
              {mealCount}{" "}
              {mealType?.charAt(0).toUpperCase() +
                mealType?.slice(1).toLowerCase()}
            </strong>{" "}
            <br />
            for your {mealCount === 1 ? "Guest" : "Guests"} at{" "}
            <strong>
              {" "}
              {cityName?.charAt(0).toUpperCase() +
                cityName?.slice(1).toLowerCase()}{" "}
            </strong>
          </Typography>
        ) : (
          <Typography variant="h6">
            You have successfully ordered <br /> your {mealType} at <br />{" "}
            <strong>
              {" "}
              {cityName?.charAt(0).toUpperCase() +
                cityName?.slice(1).toLowerCase()}{" "}
            </strong>
          </Typography>
        )}
      </Box>
      <Box className="back-btn">
        <Button
          size="large"
          variant="contained"
          fullWidth
          onClick={() => {
            navigate("/");
            dispatch(setNeedsRefetch(true));
          }}
        >
          Back to Home
        </Button>
      </Box>
      <GuestListDialogs
        open={open}
        onClose={() => setOpen(false)}
        guests={guestInfo}
      />
    </Box>
  );
};

export default ScanSuccessPage;
